<template>
  <footer class="dashboard-footer">
    <div class="container-cls d-flex">
      <div class="dashboard-footer-inner">
        <router-link
          class="text-link"
          :to="{ path: '/privacy-policy' }"
          target="_blank"
          >Privacy Policy</router-link
        >
        <div class="copy-right-text">
          &copy; {{ new Date().getFullYear() }}
          <a href="https://growgroupplc.com/pharma/" target="_blank"
            >Grow Pharma</a
          >
        </div>
        <router-link
          class="text-link"
          :to="{ path: '/terms&conditions' }"
          target="_blank"
          >Terms and Conditions</router-link
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
.dashboard-footer {
  background: #344452;
  border-top: 0.5px solid #989898;
  .dashboard-footer-inner {
    .text-link {
      display: inline-block;
      vertical-align: middle;
      font-weight: 500;
      font-size: 15px;
      line-height: 27px;
      color: #fff;
      font-family: "Palanquin", sans-serif;
    }
    .copy-right-text {
      display: inline-block;
      vertical-align: middle;
      font-weight: bold;
      font-size: 15px;
      line-height: 27px;
      color: #fff;
      font-family: "Palanquin", sans-serif;
      margin: 0 35px;
    }
    a {
      color: #fff;
    }
  }
}
</style>
